import { lazy } from "react";

export { SURVEY_PATH } from "./survey-path";
export const SurveyPage = lazy(() => import("./survey"));
export { ToSurvey } from "./to-survey";
